export const makeLink = (id: string) => {
  return `${window.location.origin}/link/${id}`;
};
